<template>
    <height-transition v-if="exists">
        <div class="repeater-item">
            <div class="wrapper">
                <slot />
            </div>

            <div class="actions">
                <a href="#" role="button" @click.prevent="exists = false"><i class="icon close"></i></a>
            </div>
        </div>
    </height-transition>
</template>

<script>
    import HeightTransition from './HeightTransition';

    export default {
        name: 'RepeaterItem',

        components: { HeightTransition },

        data: () => (
            {
                exists: true
            }
        )
    }

</script>
